import { ArrowLeft, CheckCircle2, ExternalLink } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { money } from "../../shared/domain";
import type { ActivitySnapshot } from "../../shared/types";
import { Spinner } from "../components/Spinner";
import { api } from "../lib/api";

export function DemoCompletePage() {
  const { attemptId = "" } = useParams();
  const navigate = useNavigate();
  const [activity, setActivity] = useState<ActivitySnapshot>();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { void api.activity().then(setActivity).catch((reason) => setError(String(reason))); }, []);
  const attempt = activity?.attempts.find((item) => item.id === attemptId);
  const existing = activity?.credits.find((item) => item.attemptId === attemptId);
  const complete = async (pending: boolean) => {
    setBusy(true);
    try {
      await api.completeDemoAttempt(attemptId, pending);
      navigate("/earn?credited=1", { replace: true });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Unable to complete demo offer.");
      setBusy(false);
    }
  };
  if (!activity && !error) return <div className="center-page"><Spinner /></div>;
  if (!attempt) return <div className="error-state"><h1>Offer attempt not found.</h1><Link className="button" to="/earn"><ArrowLeft />Back to Earn</Link></div>;
  return (
    <main className="demo-complete-page">
      <section className="demo-partner-card">
        <span className="demo-partner-label"><ExternalLink /> SAFE DEMO PARTNER</span>
        <h1>{attempt.offerTitle}</h1>
        <div className="demo-reward">+{money(attempt.rewardCents)}</div>
        <p>This page stands in for an external partner. In production, Bucks records the attempt first and then redirects to the approved destination.</p>
        {existing ? <div className="demo-success"><CheckCircle2 /><div><strong>Already recorded</strong><p>This attempt has a {existing.status} credit.</p></div></div> : (
          <div className="demo-actions">
            <button className="button" onClick={() => complete(false)} disabled={busy}>Complete and credit now<CheckCircle2 /></button>
            <button className="button secondary" onClick={() => complete(true)} disabled={busy}>Complete as pending</button>
            <Link className="text-link" to="/earn">Leave without completing</Link>
          </div>
        )}
        {error && <div className="form-error" role="alert">{error}</div>}
      </section>
    </main>
  );
}
